import { Provider } from '@angular/core';
import { ETAPA_PROCESSO_REPOSITORY } from './repositories/etapa-processo.repository';
import { EtapaProcessoService } from './services/etapa-processo.service';

export const ETAPAS_PROCESSO_PROVIDERS: Provider[] = [
  {
    provide: ETAPA_PROCESSO_REPOSITORY,
    useClass: EtapaProcessoService
  }
];
